import http, { createApi } from '@core/fetch'
import { API_SETMEAL_CHANGE_ORDER } from '@constant'
import { isSiDaTeam } from '@util'

export default {
  changeOrder: body => {
    if (isSiDaTeam()) {
      return http.post(
        '/hps/mainAdmin/localServerMerchant/setMeal/fourRoleGroupSort',
        {
          body
        }
      )
    } else {
      return http.post(API_SETMEAL_CHANGE_ORDER, {
        body
      })
    }
  },
  assignToMember: createApi.post(
    '/hps/mainAdmin/localServerMerchant/setMeal/assignToMember'
  )
}
